import React from "react"

export const Tweet = ({ content }) => {
  if (typeof window !== "undefined") {
    window.dataLayer.push({ event: "give_me_twitter", requires_twitter: true })
  }
  return (
    <div className="is-flex">
      <div className="mx-auto">
        <div
          dangerouslySetInnerHTML={{
            __html: content.replaceAll("x.com", "twitter.com"),
          }}
        ></div>
      </div>
    </div>
  )
}
